// extracted by mini-css-extract-plugin
export default {"wrapper":"RewardsModal_wrapper__HKqWT","body":"RewardsModal_body__DGlFd","sidebar":"RewardsModal_sidebar__0WnZA","content":"RewardsModal_content__cNq+F"};